export const SEARCH_MIN_CHAR_COUNT = 3;
